import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import membershipSlice from '../features/profile/membershipSlice';

export const store = configureStore({
  reducer: {
    membership: membershipSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
